<script>
	import { createEventDispatcher } from 'svelte'

	export let options = []
	export let value
	export let name = 'field'
	export let valid = true
	export let legacy = false
	export let label = null

	const dispatch = createEventDispatcher()

	const onChangedEvent = (event) => {
		if (event.target) {
			const sel_value = options[event.target.selectedIndex].value
			dispatch('fieldchange', sel_value)
			value = sel_value
		}
	}

	const loadValue = () => {
		internal_options
			.filter((it) => it.selected)
			.forEach((it) => {
				delete it.selected
			})
		const sel_item = internal_options.find((it) => it.value === value)
		if (sel_item) {
			sel_item.selected = true
			internal_options = internal_options
			value = sel_item.value
			dispatch('fieldchange', value)
		}
	}

	$: internal_options = options.map((it) => it)

	$: loadValue(value)
</script>

<div class="SmartSelect" class:error={valid === false}>
	{#if legacy}
		<select {name} bind:value>
			{#each internal_options as opt}
				<option value={opt.value}>{label || ''}{opt.text}</option>
			{/each}
		</select>
	{:else}
		<select {name} on:blur={onChangedEvent} on:change={onChangedEvent}>
			{#each internal_options as opt}
				<option selected={opt.selected} value={opt.value}>{opt.text}</option>
			{/each}
		</select>
	{/if}
</div>

<style>
	.SmartSelect select {
		width: 100%;
		padding: 5px 10px;
		border-radius: 0;
		background-color: transparent;
		border: 0;
		outline: 0;
		font-size: 14px;
		color: #586d7d;
		background-color: #dbe4ea;
		-webkit-appearance: none;
		border-radius: 2px;
	}
</style>
